import LazyLoading from "../common/lazyLoading";

const Tag = {
  setProductSlider: function () {
    const products = document.querySelectorAll('[data-swiper-product]');

    if (products.length > 0) {
      products.forEach((item, k) => {
        if (item.hasAttribute('data-product-ready')) return;

        const swiperEl = item.querySelector('.swiper-container');

        const swiper = new Swiper(swiperEl, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          pagination: {
            el: swiperEl.querySelector(".swiper-pagination"),
            type: "bullets",
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 4
          },
        });

        const colors = item.querySelectorAll('[data-color-ref]');
        const slides = item.querySelectorAll('[data-slide-ref]');
        const nameRef = item.querySelectorAll('[data-name-ref]');
        const priceRef = item.querySelectorAll('[data-price-ref]');
        const parcelRef = item.querySelectorAll('[data-parcel-ref]');
        const infoProduct = item.querySelector('.text');

        if (colors.length > 0) {
          colors.forEach((color, j) => {
            let ref = color.getAttribute('data-color-ref');
            const links = color.closest('.product-block-swiper').querySelectorAll('.link_product');
            const url = color.getAttribute('data-link-image');

            color.addEventListener("click", () => {
              if (color.classList.contains('-active')) {
                infoProduct.classList.remove('-active')

                if (slides.length > 0) slides.forEach(slide => {
                  if (slide.getAttribute('data-slide-ref') == '') {
                    slide.classList.remove('-hide');
                  } else {
                    slide.classList.add('-hide');
                  }
                });
                if (nameRef.length > 0) nameRef.forEach(name => {
                  if (name.getAttribute('data-name-ref') == color.getAttribute('data-color-ref')) {
                    name.classList.remove('-hide');
                  } else {
                    name.classList.add('-hide');
                  }
                })
                if (priceRef.length > 0) priceRef.forEach(price => {
                  if (price.getAttribute('data-price-ref') == color.getAttribute('data-color-ref')) {
                    price.classList.remove('-hide');
                  } else {
                    price.classList.add('-hide');
                  }
                })
                if (parcelRef.length > 0) parcelRef.forEach(parcel => {
                  if (parcel.getAttribute('data-parcel-ref') == color.getAttribute('data-color-ref')) {
                    parcel.classList.remove('-hide');
                  } else {
                    parcel.classList.add('-hide');
                  }
                })
                swiper.update();
                color.classList.remove('-active');
                template_store.setProductLinks(links);
              } else {
                infoProduct.classList.add('-active')

                if (slides.length > 0) slides.forEach(slide => {
                  if (slide.getAttribute('data-slide-ref') == color.getAttribute('data-color-ref')) {
                    slide.classList.remove('-hide');
                  } else {
                    slide.classList.add('-hide');
                  }
                });
                if (nameRef.length > 0) nameRef.forEach(name => {
                  if (name.getAttribute('data-name-ref') == color.getAttribute('data-color-ref')) {
                    name.classList.remove('-hide');
                  } else {
                    name.classList.add('-hide');
                  }
                })
                if (priceRef.length > 0) priceRef.forEach(price => {
                  if (price.getAttribute('data-price-ref') == color.getAttribute('data-color-ref')) {
                    price.classList.remove('-hide');
                  } else {
                    price.classList.add('-hide');
                  }
                })
                if (parcelRef.length > 0) parcelRef.forEach(parcel => {
                  if (parcel.getAttribute('data-parcel-ref') == color.getAttribute('data-color-ref')) {
                    parcel.classList.remove('-hide');
                  } else {
                    parcel.classList.add('-hide');
                  }
                })
                swiper.update();

                colors.forEach(c => {
                  c == color ? c.classList.add('-active') : c.classList.remove('-active');
                })

                template_store.setProductLinks(links, url);
              }
            })

          })
        }

        const dropdownItem = item.querySelectorAll('[data-item-dropdown]');

        if (dropdownItem.length > 0) {
          dropdownItem.forEach(btn => {
            const btnColor = btn.querySelector('[data-btn-color]');
            btnColor.addEventListener('click', () => {
              btn.classList.toggle('dropdown');
            })
          });
        }

        item.setAttribute('data-product-ready', true)
      })
    }
  },
  infiniteScroll: {
    $productBox: $(".list-products"),
    $pagination: $(".pagination"),
    $paginationTotal: $(".pagination").data("total-pages"),
    $paginationCurrentPage: $(".pagination").data("actual-page"),
    $paginationNextUrl: $(".pagination").data("next-url") || "",
    $loadMoreButton: $("[data-ver-mais]"),

    loadProducts: function () {
      var _this = this;
      this.changeState("is-loading", "Mais produtos");

      let nextUrl = _this.$paginationNextUrl;
      if (nextUrl.includes('&_')) nextUrl = nextUrl.split('&_')[0];
      console.log('nextUrl', nextUrl);

      $.ajax({
        cache: false,
        type: "GET",
        url: nextUrl,
        dataType: "html",
      })
        .done(function (html) {
          //console.log("done");
          _this.update(html);
          //template_store.tag.orderSizes();
        })
        .fail(function (resp) {
          //console.log("fail: ", resp);
        });
    },
    update: function (html) {
      // console.log('vendo a page', html);
      this.$productBox.append($(html).find(".product-block, .product-block-swiper"));
      this.$paginationCurrentPage = $(html)
        .find(".pagination")
        .data("actual-page");
      this.$paginationNextUrl =
        $(html).find(".pagination").data("next-url") || "";
      $(".list-products").removeClass("carregando");

      LazyLoading.update();
      store.getPriceProd();
      template_store.setProductColors();
      Tag.setProductSlider();
    },
    changeState: function (state, text) {
      this.$loadMoreButton.removeClass();
      if (state != "") {
        this.$loadMoreButton.addClass(state);
        this.$loadMoreButton.find(".more").text(text);
      }
    },
    setLoader: function () {
      //console.log('oie3');
      this.$loadMoreButton = $("[data-ver-mais]");
      this.$loadMoreButton.removeClass("hide");
      var _this = this;

      this.$loadMoreButton.on("click", function (event) {
        event.preventDefault();

        if (_this.$paginationCurrentPage !== _this.$paginationTotal) {
          _this.loadProducts();
        } else {
          //console.log("fim");
        }
      });

      $(window).on("scroll", function () {
        var currentScroll = $(window).scrollTop() + $(window).height() + 1000;
        var target = $("footer").offset().top;

        if (currentScroll > target) {
          if (_this.$paginationCurrentPage !== _this.$paginationTotal) {
            if (!$(".list-products").hasClass("carregando")) {
              $(".list-products").addClass("carregando");
              _this.loadProducts();
            }
          } else {
            $(".list-products").addClass("all-loaded");
          }
        }
      });
    },
    clearFilters: function () {
      $(document).ready(function () {
        if (document.location.search.length) {
          $(".clear").hide();
          $(".clear").show();
        } else {
          $(".clear").hide();
        }
      });
    },
    init: function () {
      var _this = this;
      _this.clearFilters();

      console.log('iniciou');

      //console.log('oie');
      //console.log(this.$paginationCurrentPage)
      //console.log(this.$paginationTotal)
      if (this.$paginationCurrentPage !== this.$paginationTotal) {
        //console.log('oie2');
        this.setLoader();
      }
    },
  },
  init: function () {
    console.log('Tag init called');
    const _this = this;
    _this.infiniteScroll.init();
    _this.setProductSlider();
  },
}

window.addEventListener("DOMContentLoaded", () => {
  Tag.init();
})
